import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { CertificationInstructorModel } from '../../../../models/certificationModel';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getAllControlsErrors, updateFormGroupValidity, markFormGroupTouched } from '../../../../helpers/utils';
import { AlertService } from '../../../../shared/services/alert.service';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { closeEditInstructor, deleteInstructor, deleteInstructorSuccess, saveInstructor, saveInstructorSuccess, updateInstructorForm } from '../../../../core/store/certification/certification.action';
import { loadEmployeeUsers } from '../../../../core/store/employee/employee.action';
import { UserAutoCompleteItem, ModifiedSelectItem } from '../../../../models/utilModels';

@Component({
    selector: 'app-instructor-edit-certification',
    templateUrl: './instructor-edit-certification.component.html',
  styleUrls: ['./instructor-edit-certification.component.scss'],
    standalone: false
})
export class InstructorEditCertificationComponent extends BaseComponent implements OnInit {
  display: boolean = false;
  title: string;
  form: UntypedFormGroup;
  disableButtons: boolean = true;
  hideDelete: boolean = true;
  campusId: number = 0;
  showOnlyActiveEmployees: boolean = true;

  certificationTypes: ModifiedSelectItem[];
  selectedUser: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit() {
    this.form = this.createForm();
    this.subs.push(
      this.store.select(s => s.certificationState.editingInstructor).subscribe(editingInstructor => {
        if (this.display && !editingInstructor) {
          this.resetForm();
        }
        this.display = editingInstructor;
      }),
      this.store.select(s => s.certificationState.savingInstructor).subscribe(savingInstructor => {
        this.disableButtons = savingInstructor;
      }),
      this.store.select(s => s.certificationState.selectedInstructor).subscribe(instr => {        
        if (instr === null || Object.keys(instr).length == 0) {
          this.resetForm();
          return;
        }

        this.title = "Edit Instructor #" + instr.instructorId;
        this.form.get("instructorId").setValue(instr.instructorId);
        this.form.get("userId").setValue(instr.userId);
        this.form.get("certificationTypeId").setValue(instr.certificationTypeId);
        this.form.get("archived").setValue(instr.archived);
        this.selectedUser = { name: instr.firstName + " " + instr.lastName, id: instr.userId };
        this.hideDelete = false;        
      }),
      this.store.select(s => s.certificationState.certificationTypes).subscribe(types => {
        if (types && types.length > 0) {
          this.certificationTypes = types.map(x => ({ label: x.label, value: x.value }));
          this.certificationTypes.unshift({ label: '', value: 0 });
        }
        else {
          this.certificationTypes = [{ label: 'loading...', value: 0 }]
        }
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.actions$.pipe(
        ofType(saveInstructorSuccess),
        tap(action => {
          this.closeModal();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(deleteInstructorSuccess),
        tap(action => {
          this.closeModal();
        })
      ).subscribe(),
    );
  }

  createForm() {
    let f = this.fb.group({
      instructorId: this.fb.control(0),
      userId: this.fb.control(0, [Validators.required]),
      certificationTypeId: this.fb.control(0, [Validators.required]),
      archived: this.fb.control(false)      
    });

    return f;
  }

  resetForm() {
    this.title = "Add Instructor";
    this.hideDelete = true;
    this.selectedUser = { name: "", id: 0 };
    this.form.reset({
      instructorId: 0,
      userId: 0,
      certificationTypeId: 0,
      archived: false      
    });    
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: this.campusId,
      payrollClassificationId: null,
      showTerminated: !this.showOnlyActiveEmployees,
      showInactive: !this.showOnlyActiveEmployees
    }));
  }

  setUserAfterStaffChange(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.form.get('userId').setValue(selectedUser.value.id);
  }

  clearUserAfterClear(event) {
    
    this.form.get('userId').setValue(0);
  }

  closeModal() {
    this.store.dispatch(closeEditInstructor());
  }

  saveInstructorEdits() {
    updateFormGroupValidity(this.form);
    if (this.form.valid) {      
      this.store.dispatch(saveInstructor({ instructor: this.form.value as CertificationInstructorModel }));
    } else {
      markFormGroupTouched(this.form);
    }
  }

  deleteInstructor() {
    this.alertService.confirm('Archive/Delete Instructor',
      'Are you sure you want to archive/delete this instructor?')
      .subscribe(
        answer => {
          if (answer) {
            let instructorId = this.form.get("instructorId").value;
            if (instructorId <= 0) {
              this.alertService.error("Instructor not found");
              return;
            }
            this.store.dispatch(deleteInstructor({ instructorId: instructorId }));
          }
        }, error => {
        }
      );
  }
}
